import { createSlice } from "@reduxjs/toolkit";
import { getPopupList } from "./thunk";

export interface IState {
  lstPopup: any;
  isPopupLoading: boolean;
  isPopupSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstPopup: null,
  isPopupLoading: false,
  isPopupSuccess: false,

  error: {},
};

const PopupSlice = createSlice({
  name: "Popup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getPopupList.pending, (state: IState, action: any) => {
      state.isPopupLoading = true;
    });
    builder.addCase(
      getPopupList.fulfilled,
      (state: IState, action: any) => {
        state.lstPopup = action.payload.data;
        state.isPopupSuccess = true;
        state.isPopupLoading = false;
      }
    );
    builder.addCase(
      getPopupList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isPopupSuccess = false;
        state.isPopupLoading = false;
      }
    );
  },
});

export default PopupSlice.reducer;